// assets/infinite-scroll.js
(() => {
    // near top
const DEBUG = true;

// inside class InfiniteScroll constructor, after you set up observer:
if (DEBUG) console.debug('[IS] init for section', this.sectionId);

// at the bottom, after you define initAll()
window.__initInfiniteScroll = initAll; // <-- allows manual re-init from console


  const SELECTORS = { container: '[data-infinite-scroll]', grid: '[data-products-grid]' };

function buildSectionURL(nextUrl, sectionId) {
  if (!nextUrl) return '';
  const url = new URL(nextUrl, window.location.origin);

  const merged = new URLSearchParams(url.search);
  const current = new URLSearchParams(window.location.search);

  // Keep nextUrl’s page params; only add current filters/sort if missing
  current.forEach((v, k) => { if (!merged.has(k)) merged.set(k, v); });

  if (!merged.has('section_id')) merged.set('section_id', sectionId);

  url.search = merged.toString();
  return url.pathname + url.search;   // ✅ no extra '?'
}

  class InfiniteScroll {
    constructor(container) {
      this.container = container;
      this.sectionId = container.getAttribute('data-section-id');
      this.grid = container.querySelector(SELECTORS.grid);
      this.sentinel = container.querySelector(`#infinite-scroll-sentinel-${this.sectionId}`);
      this.loading = false;
      if (!this.grid || !this.sentinel) return;

      // Avoid double init
      if (container.__infiniteScroll) return;
      container.__infiniteScroll = this;

      this.observer = new IntersectionObserver(
        (entries) => entries.forEach((e) => e.isIntersecting && this.loadNext()),
        { rootMargin: '0px 0px 400px 0px' } // prefetch before reaching bottom
      );
      this.observer.observe(this.sentinel);
    }

    get nextUrl() { return this.container.getAttribute('data-next-url') || ''; }
    set nextUrl(val) { val ? this.container.setAttribute('data-next-url', val) : this.container.removeAttribute('data-next-url'); }

    async loadNext() {
        if (this.loading || !this.nextUrl) { if (!this.nextUrl) this.teardown(); return; }
    this.loading = true;

    const url = buildSectionURL(this.nextUrl, this.sectionId);

    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();

      const tpl = document.createElement('template');
      tpl.innerHTML = html.trim();

      const fetchedContainer = tpl.content.querySelector('[data-infinite-scroll]');
      const fetchedGrid = tpl.content.querySelector('[data-products-grid]');
      if (!fetchedGrid) throw new Error('Grid not found in fetched HTML');

      // ✅ Only take product cards; drop any sentinel that came with the page
      const newItems = Array.from(fetchedGrid.children).filter(
        (el) => !(el.id && el.id.startsWith('infinite-scroll-sentinel-'))
      );
      newItems.forEach((el) => this.grid.appendChild(el));

      // ✅ Keep OUR sentinel at the very end so the observer fires for the next page
      this.grid.appendChild(this.sentinel);

      // Update next url from the fetched section
      const newNext = fetchedContainer?.getAttribute('data-next-url') || '';
      this.nextUrl = newNext;

      if (typeof initializeScrollAnimationTrigger === 'function') {
        initializeScrollAnimationTrigger(this.grid);
      }

      if (!this.nextUrl) this.teardown();
    } catch (err) {
      console.error('[InfiniteScroll] loadNext failed:', err);
      this.teardown();
    } finally {
      this.loading = false;
    }
    }

    teardown() {
      try { this.observer && this.observer.disconnect(); } catch (_) {}
    }
  }

  function initAll() {
    document.querySelectorAll(SELECTORS.container).forEach((el) => new InfiniteScroll(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('collection:reloaded', initAll);
  window.addEventListener('popstate', () => setTimeout(initAll, 0));
})();
